/// <reference path="../../types/signalr.d.ts" />

namespace SP {
    export class Droppable {
        static current: Droppable;
        element: HTMLElement;
        types: string[];
        callback: (type: string, d: any) => any;
        active = false;
        bound = false;
        constructor(element: HTMLElement, types: string[], dropCallback: (type: string, d: any) => any) {
            this.element = element;
            this.types = types;
            this.callback = dropCallback;

            let rect = this.element.getBoundingClientRect();

            let move = (t: any) => {

                let e = t as MouseEvent;

                if (t.touches && t.touches.length)
                    e = t.touches[0];


                var z = SP.zoom() as number;

                if (rect.x < e.clientX / z &&
                    rect.x + rect.width > e.clientX / z &&
                    rect.y < e.clientY / z &&
                    rect.y + rect.height > e.clientY / z) {
                    if (!this.active) {
                        over();
                    }

                }
                else {
                    if (this.active) {
                        out();
                    }
                }
            }

            let touch = () => {
                rect = this.element.getBoundingClientRect();
                if (!this.bound) {
                    document.addEventListener("mouseup", touchEnd);
                    document.addEventListener("touchend", touchEnd);
                    document.addEventListener("mousemove", move);
                    document.addEventListener("touchmove", move);
                    this.bound = true;
                }


            }

            let touchEnd = () => {
                if (this.bound) {
                    document.removeEventListener("mouseup", touchEnd);
                    document.removeEventListener("touchend", touchEnd);
                    document.removeEventListener("mousemove", move);
                    document.removeEventListener("touchmove", move);
                    this.bound = false;
                }

            }

            document.body.addEventListener("mousedown", touch);
            document.body.addEventListener("touchstart", touch);







            var out = () => {
                this.element.removeEventListener("pointerleave", out);
                this.clear();
            }

            var over = () => {
                if (!this.active && Draggable.currentItem != null && this.types.indexOf(Draggable.currentItem.type) != -1) {
                    this.element.addEventListener("pointerleave", out);
                    this.focus();
                }
            }

            //this.element.addEventListener("pointerenter", over);
        }

        focus() {
            Droppable.current?.clear();
            Droppable.current = this;
            this.active = true;
            this.element.classList.add("droppable_active");

        }


        clear() {
            if (this.active) {
                this.active = false;
                this.element.classList.remove("droppable_active");
                Droppable.current = null;

            }
        }

    }


    export class Draggable {
        static dragContainer: HTMLDivElement;
        static currentItem: Draggable;

        element: HTMLElement;
        dragClone: HTMLElement;
        dragging = false;
        triggered = false;
        initialized = false;
        type: string;
        data: any;
        itemStartPosition = new SP.Point();
        clickStartPosition = new SP.Point();
        mousePosition = new SP.Point();
        mouseOffset = new SP.Point();


        constructor(element: HTMLElement, type: string, data: any) {
            this.element = element;
            this.type = type;
            this.data = data;

            let dragStart = async (x: any) => {
                //x.preventDefault();
                let e: MouseEvent = x;
                if (x.touches && x.touches[0]) e = x.touches[0] as MouseEvent;
                this.clickStartPosition.set(e.screenX, e.screenY);


                if (!this.dragging) {
                    this.dragging = true;
                    document.body.addEventListener("touchend", dragEnd);
                    document.body.addEventListener("mouseup", dragEnd);
                    document.body.addEventListener("touchmove", drag);
                    document.body.addEventListener("mousemove", drag);
                }
            };


            let drag = (x: any) => {
                let e: MouseEvent = x;
                if (x.touches && x.touches[0]) e = x.touches[0] as MouseEvent;
                this.mousePosition.set(e.screenX, e.screenY);
                this.mouseOffset.set(this.mousePosition.x - this.clickStartPosition.x, this.mousePosition.y - this.clickStartPosition.y);


                if (!this.triggered && this.mouseOffset.length() > 10) {
                    this.initialize();
                    this.triggered = true;
                    Draggable.currentItem = this;
                }
                else if (this.triggered) {
                    var z = SP.zoom() as number;
                    this.dragClone.style.left = (this.itemStartPosition.x + (this.mouseOffset.x / window.devicePixelRatio / z)) + "px";
                    this.dragClone.style.top = (this.itemStartPosition.y + (this.mouseOffset.y / window.devicePixelRatio / z)) + "px";
                }


            };

            let dragEnd = () => {
                if (this.dragging) {
                    document.body.removeEventListener("touchend", dragEnd);
                    document.body.removeEventListener("mouseup", dragEnd);
                    document.body.removeEventListener("touchmove", drag);
                    document.body.removeEventListener("mousemove", drag);

                    this.dragging = false;
                    this.triggered = false;

                    if (Droppable.current != null) {
                        Droppable.current.callback(this.type, this.data);
                        Droppable.current.clear();
                    }

                    Draggable.currentItem = null;
                    console.log("EndDrag");
                    if (Draggable.dragContainer) Draggable.dragContainer.style.display = "none"; if (this.dragClone) {
                        this.dragClone.remove();
                        this.dragClone = null;
                    }
                }


            };

            this.element.addEventListener("mousedown", dragStart);
            this.element.addEventListener("touchstart", dragStart);

        }





        async initialize() {
            if (!this.initialized) {
                if (!Draggable.dragContainer) {
                    console.log("initialize Drag");
                    Draggable.dragContainer = document.createElement("div");
                    Draggable.dragContainer.classList.add("drag_container");
                    document.body.append(Draggable.dragContainer);
                }
            }

            this.dragClone = SP.duplicate(this.element);
            await SP.sleep(0);
            var metrics = this.element.getBoundingClientRect();
            this.dragClone.style.width = metrics.width + "px";
            this.dragClone.style.height = metrics.height + "px";
            this.dragClone.style.left = metrics.left + "px";
            this.dragClone.style.top = metrics.top + "px";
            this.dragClone.style.boxShadow = "10px 10px 10px #00000055";


            Draggable.dragContainer.appendChild(this.dragClone);
            Draggable.dragContainer.style.display = "block";
            this.itemStartPosition.set(metrics.left, metrics.top);
        }
    }
}